import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
} from '@mui/material';

interface EditMovieModalProps {
  show: boolean;
  onHide: () => void;
  onEditMovie: (movie: any) => void;
  movie: {
    id: string;
    title: string;
    year: number;
    image: string;
    type: string;
  };
}

const EditMovieModal = ({
  show,
  onHide,
  onEditMovie,
  movie,
}: EditMovieModalProps) => {
  const [title, setTitle] = useState(movie.title);
  const [year, setYear] = useState(movie.year);
  const [type, setType] = useState(movie.type);
  const [image, setImage] = useState(movie.image);

  useEffect(() => {
    if (show) {
      setTitle(movie.title);
      setYear(movie.year);
      setType(movie.type);
      setImage(movie.image);
    }
  }, [show, movie]);

  const handleSaveChanges = () => {
    onEditMovie({ ...movie, title, year, type, image });
    onHide();
  };

  return (
    <Dialog open={show} onClose={onHide} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Movie</DialogTitle>

      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField label="Title" value={title} onChange={(e) => setTitle(e.target.value)} />
          <TextField label="Year" type="number" value={year} onChange={(e) => setYear(+e.target.value)} />

          <FormControl>
            <InputLabel>Type</InputLabel>
            <Select value={type} label="Type" onChange={(e) => setType(e.target.value)}>
              <MenuItem value="Blu-Ray">Blu-Ray</MenuItem>
              <MenuItem value="4K Ultra HD">4K Ultra HD</MenuItem>
            </Select>
          </FormControl>

          <TextField label="Image URL" value={image} onChange={(e) => setImage(e.target.value)} />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onHide}>Cancel</Button>
        <Button variant="contained" onClick={handleSaveChanges}>
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditMovieModal;